// extracted by mini-css-extract-plugin
export default {"fullWrapper":"TermsofUse_fullWrapper__i2115","container":"TermsofUse_container__X1n4S","logo":"TermsofUse_logo__j-2mO"};